import classNames from 'classnames';
import { IntlKey } from 'locales';
import { ButtonHTMLAttributes, HTMLAttributes } from 'react';
import { FormattedMessage } from 'react-intl';

type UnderlyingHeaderProps = {
  labelKey: IntlKey;
  onClear: null | (() => void);
  onCopyAll: () => void;
  clearDisabled?: boolean;
  resultShown: boolean;
  onToggleResult: () => void;
  isCopyButtonVisible?: boolean;
};

function IconButton(props: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'>) {
  return <button className="btn btn-flat-secondary btn-icon" {...props} />;
}

function Icon({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <i className={classNames('icon icon-outlined', className)} {...props} />;
}

export function UnderlyingHeader({
  onClear,
  clearDisabled,
  onCopyAll,
  resultShown,
  onToggleResult,
  isCopyButtonVisible,
  labelKey,
}: UnderlyingHeaderProps) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-1">
      <label htmlFor="underlyings" className="text-secondary">
        <FormattedMessage id={labelKey} />
      </label>
      <div>
        {isCopyButtonVisible && (
          <IconButton onClick={onCopyAll}>
            <Icon>content_copy</Icon>
          </IconButton>
        )}
        {onClear !== null && (
          <IconButton onClick={onClear} disabled={clearDisabled}>
            <Icon>delete_sweep</Icon>
          </IconButton>
        )}
        <IconButton onClick={onToggleResult}>
          <Icon className={resultShown ? 'text-info' : undefined}>format_list_bulleted</Icon>
        </IconButton>
      </div>
    </div>
  );
}
